export default "__VITE_ASSET__BbCnEMp8__"